<template>
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="listQuery" :inline="true">
        <el-form-item label="部门" prop="bmmc">
          <el-select
            ref="bmmc"
            v-model="listQuery.bmmc"
            placeholder="所属部门"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="项目名称"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="更新日期" prop="status">
          <el-date-picker
            v-model="time"
            type="daterange"
            size="small"
            style="width: 300px"
            range-separator="——"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="listQuery.createTime"
            @change="handleChangeTime"
            @keyup.enter.native="getList"
          ></el-date-picker>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="handleAdd('新增')"
            style="margin-left: 15px"
            >新增</el-button
          >
        </span>
      </el-form>
    </div>
    <div class="mycontainer">
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="项目名称"
          prop="xmjc"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmjc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="部门"
          prop="bmmc"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="存款数据量（条）"
          prop="cksjl"
          :show-overflow-tooltip="true"
          min-width="130px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cksjl }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="贷款数据量（条）"
          prop="dksjl"
          min-width="120px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.dksjl }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="两周全库备份"
          prop="lzqkbf"
          min-width="120px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lzqkbf ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="每周关键表备份"
          prop="mzgjbbf"
          min-width="120px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.mzgjbbf ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="数据更新日期"
          prop="createTime"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="系统使用率"
          prop="xtsyl"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xtsyl }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="备注"
          prop="bz"
          min-width="120px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bz }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="操作人"
          prop="czr"
          min-width="120px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.czr }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          fixed="right"
          align="left"
          min-width="80px"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-plus"
              @click="handleAdd('修改', scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="saveForm.title"
        :visible.sync="addDialogFlag"
      >
        <el-form
          ref="saveForm"
          :model="saveFormParams"
          :rules="rules"
          label-width="100px"
          id="save-form"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="部门" prop="bmbh">
                <el-select
                  ref="bmmc"
                  v-model="saveFormParams.bmmc"
                  placeholder="所属部门"
                  clearable
                  filterable
                  size="small"
                  style="width: 200px"
                  class="filter-item"
                  @change="handleChangeAddBm"
                >
                  <el-option
                    v-for="item in bmList"
                    :key="item.bmmc"
                    :label="item.bmmc"
                    :value="item.bmbh"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="xmbh">
                <el-select
                  ref="xmbh"
                  v-model="saveFormParams.xmbh"
                  placeholder="项目名称"
                  clearable
                  filterable
                  size="small"
                  style="width: 200px"
                  class="filter-item"
                >
                  <el-option
                    v-for="item in xmList"
                    :key="item.xmbh"
                    :label="item.xmjc"
                    :value="item.xmbh"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label=" 存款数据量（条）" prop="cksjl">
                <el-input
                  v-model="saveFormParams.cksjl"
                  placeholder="请输入正整数"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="贷款数据量（条）" prop="dksjl">
                <el-input
                  v-model="saveFormParams.dksjl"
                  placeholder="请输入正整数"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="两周全库备份" prop="lzqkbf">
                <el-select v-model="saveFormParams.lzqkbf" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="每周关键表备份" prop="mzgjbbf">
                <el-select
                  v-model="saveFormParams.mzgjbbf"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="系统使用率" prop="xtsyl">
                <el-input
                  v-model="saveFormParams.xtsyl"
                  placeholder="系统使用率"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="bz">
                <el-input v-model="saveFormParams.bz" placeholder="备注" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer">
          <el-button
            type="primary"
            size="small"
            @click="saveItWeekly()"
            style="margin-right: 15px"
            >确 定</el-button
          >
          <el-button size="small" @click="addDialogFlag = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import {
  getItWeeklyList,
  getBmxxList,
  getXmxxList,
  saveItWeeklConfig,
} from "@/api/itWeekly.js";
import { formatMomentDate } from "@/utils/utils";
export default {
  // 列表分页
  name: "itWeekly",
  components: { Pagination },

  data() {
    // const rolesAllClass = [{ value: 0, name: '超级管理员' }, { value: 1, name: '普通管理员' }, { value: 2, name: '普通员工' }, { value: 3, name: '普通用户' }]
    return {
      height: 100,
      listQuery: {
        xmbh: "",
        bmbh: "",
        qsrq: "",
        jsrq: "",
        page: 1,
        pageSize: 10,
      },
      listLoading: true,
      params: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "DS,SW,SD,TS,JC,YP", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        xmlx: "DS,SW,SD,TS,JC,YP", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "1,3", //合同状态，多个,隔开，如1,3
        xmzt: "1", //合同状态，多个,隔开，如1,3
      },
      time: [],
      total: 0,
      list: [],
      bmList: [],
      xmList: [],
      addDialogFlag: false,
      saveFormParams: {
        id: "",
        xmbh: "",
        bmbh: "",
        bmmc: "",
        cksjl: "",
        dksjl: "",
        lzqkbf: 1,
        mzgjbbf: 1,
        bz: "",
      },
      saveForm: {
        title: "新增",
      },
      options: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      rules: {
        xmbh: [{ required: true, message: "项目不能为空", trigger: "blur" }],
        cksjl: [
          { required: true, message: "存款数据量不能为空", trigger: "blur" },
        ],
        dksjl: [
          { required: true, message: "贷款数据量不能为空", trigger: "blur" },
        ],
        lzqkbf: [
          { required: true, message: "两周全库备份不能为空", trigger: "blur" },
        ],
        mzgjbbf: [
          {
            required: true,
            message: "每周关键表备份不能为空",
            trigger: "blur",
          },
        ],
        xtsyl: [
          {
            required: true,
            message: "系统使用率不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    getBmxxList(this.params.type, this.params.range).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
    this.getList();
    getXmxxList(
      this.params.xmlx,
      this.params.range,
      this.params.xmzt,
      this.listQuery.bmbh,
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
  },
  methods: {
    getList() {
      if (this.listQuery.bmmc) {
        this.listQuery.bmbh = this.listQuery.bmmc;
      }
      const params = { ...this.listQuery };
      params.bmmc = null;
      getItWeeklyList(params).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 95;
        }
      });
    },
    handleChangeBm(i) {
      this.listQuery.bmbh = i;
      this.listQuery.bmmc = i;
      getXmxxList(
        this.params.xmlx,
        this.params.range,
        this.params.xmzt,
        i,
        "1,2,3"
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },
    handleChangeAddBm(i) {
      getXmxxList(
        this.params.xmlx,
        this.params.range,
        this.params.xmzt,
        i,
        ""
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },

    handleAdd(title, data) {
      this.addDialogFlag = true;
      this.saveForm.title = title;
      this.saveFormParams = {
        id: "",
        xmbh: "",
        cksjl: "",
        dksjl: "",
        lzqkbf: 1,
        mzgjbbf: 1,
        bz: "",
        bmbh: "",
        bmmc: "",
        xtsyl: "",
      };
      if (data) {
        this.saveFormParams = { ...data };
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleChangeTime(value) {
      if (!value) {
        this.listQuery.qsrq = "";
        this.listQuery.jsrq = "";
        return;
      }
      this.listQuery.qsrq = formatMomentDate(value[0]);
      this.listQuery.jsrq = formatMomentDate(value[1]);
    },
    saveItWeekly() {
      let r = /(^[1-9]\d*$)/;
      const isFloat = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!r.test(+this.saveFormParams.cksjl)) {
        this.$message({
          type: "error",
          message: "存款数据量输入框请输入正整数!",
        });
        return;
      }
      if (!r.test(+this.saveFormParams.dksjl)) {
        this.$message({
          type: "error",
          message: "贷款数据量输入框请输入正整数!",
        });
        return;
      }
      if (!isFloat.test(this.saveFormParams.xtsyl)) {
        this.$message({
          type: "error",
          message: "系统使用率输入框请输入非负数字!",
        });
        return;
      }
      const params = {
        id: this.saveFormParams.id,
        xmbh: this.saveFormParams.xmbh,
        cksjl: this.saveFormParams.cksjl,
        dksjl: this.saveFormParams.dksjl,
        lzqkbf: this.saveFormParams.lzqkbf,
        mzgjbbf: this.saveFormParams.mzgjbbf,
        bz: this.saveFormParams.bz,
        xtsyl: this.saveFormParams.xtsyl,
      };
      // return;
      // if (this.saveFormParams.bmmc) {
      //   this.saveFormParams.bmbh = this.saveFormParams.bmmc;
      //   params.bmbh = this.saveFormParams.bmmc;
      // }
      saveItWeeklConfig(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.addDialogFlag = false;
          this.getList();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
</style>
